import React from 'react';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { resolveImg } from './shared';

export const Header = ({ theme, isScrolled, mobileMenuOpen, setMobileMenuOpen, menuItems, activeSection, hoveredMenu, setHoveredMenu, scrollToSection, topbarLinks, siteSettings, getMenuStyle, i18n }) => (
  <header
    className={`border-b transition-all duration-500 ${isScrolled ? 'header-scrolled border-transparent' : 'border-slate-200'}`}
    style={{ backgroundColor: isScrolled ? `${theme.header_bg}f5` : theme.header_bg, backdropFilter: isScrolled ? 'blur(12px)' : 'none' }}
  >
    <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
      <div className="flex justify-between items-center h-14 md:h-16 lg:h-20">
        <div className="flex md:hidden lg:flex items-center space-x-3">
          <img src={siteSettings.logo_url ? resolveImg(siteSettings.logo_url) : "/logo-solar-green.png"} alt="Solar GREEN Logo" className="h-10 lg:h-12 w-auto object-contain" data-testid="header-logo" />
        </div>
        <nav className="hidden md:flex items-center space-x-0.5 lg:space-x-1 flex-1 md:justify-center lg:justify-end" data-testid="main-nav">
          {menuItems.map((item) => (
            item.link ? (
              <a key={item.id} href={item.link}
                className="menu-item px-2 md:px-2.5 lg:px-3 xl:px-4 py-1.5 lg:py-2 font-medium uppercase text-[11px] md:text-xs xl:text-sm tracking-wide rounded-lg whitespace-nowrap"
                style={{ fontFamily: `${theme.font_body}, sans-serif`, transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', color: theme.menu_text }}
                data-testid={`nav-${item.id}`}
                onMouseEnter={(e) => { e.target.style.color = theme.primary_color; e.target.style.backgroundColor = `${theme.primary_color}15`; }}
                onMouseLeave={(e) => { e.target.style.color = theme.menu_text; e.target.style.backgroundColor = 'transparent'; }}
              >{item.label}</a>
            ) : (
              <button key={item.id} onClick={() => scrollToSection(item.id)}
                onMouseEnter={() => setHoveredMenu(item.id)} onMouseLeave={() => setHoveredMenu(null)}
                className="menu-item px-2 md:px-2.5 lg:px-3 xl:px-4 py-1.5 lg:py-2 font-medium uppercase text-[11px] md:text-xs xl:text-sm tracking-wide rounded-lg whitespace-nowrap"
                style={{ fontFamily: `${theme.font_body}, sans-serif`, transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', ...getMenuStyle(item.id) }}
                data-testid={`nav-${item.id}`}
              >{item.label}</button>
            )
          ))}
          {topbarLinks.nav_extra_url && (
            <a href={topbarLinks.nav_extra_url} target={topbarLinks.nav_extra_url.startsWith('http') ? '_blank' : '_self'} rel="noopener noreferrer"
              className="menu-item px-2 md:px-2.5 lg:px-3 xl:px-4 py-1.5 lg:py-2 font-medium uppercase text-[11px] md:text-xs xl:text-sm tracking-wide rounded-lg flex items-center gap-1 whitespace-nowrap"
              style={{ fontFamily: `${theme.font_body}, sans-serif`, color: '#0ea5e9', transition: 'all 0.3s' }} data-testid="nav-extra-link"
            >
              <svg className="w-3 h-3 lg:w-3.5 lg:h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              {topbarLinks.nav_extra_label || 'Odkaz'}
            </a>
          )}
          <LanguageSwitcher />
        </nav>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2" style={{ color: theme.menu_text }} data-testid="mobile-menu-toggle" aria-label={mobileMenuOpen ? 'Zavřít menu' : 'Otevřít menu'}>
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
    </div>
    {mobileMenuOpen && (
      <div className="md:hidden glass border-t border-white/20" data-testid="mobile-menu">
        <div className="px-4 py-4 space-y-1">
          {menuItems.map((item) => (
            item.link ? (
              <a key={item.id} href={item.link} className="block w-full text-left py-3 px-4 rounded-lg font-medium transition-all duration-200" style={{ color: theme.menu_text }} data-testid={`mobile-nav-${item.id}`}>{item.label}</a>
            ) : (
              <button key={item.id} onClick={() => scrollToSection(item.id)}
                className="block w-full text-left py-3 px-4 rounded-lg font-medium transition-all duration-200"
                style={{ color: activeSection === item.id ? theme.primary_color : theme.menu_text, backgroundColor: activeSection === item.id ? `${theme.primary_color}10` : 'transparent' }}
                data-testid={`mobile-nav-${item.id}`}
              >{item.label}</button>
            )
          ))}
          <div className="py-2 px-4"><LanguageSwitcher /></div>
        </div>
      </div>
    )}
  </header>
);
